// frontend/src/components/profile/NotificationPreferences.jsx
import React, { useState, useEffect } from 'react';
import { FaVolumeUp, FaVolumeMute } from 'react-icons/fa';
import notificationSoundService from '../../services/notificationSoundService';

const NotificationPreferences = () => {
  const [soundEnabled, setSoundEnabled] = useState(notificationSoundService.areSoundsEnabled());
  const [message, setMessage] = useState({ type: '', content: '' });

  useEffect(() => {
    // Initialiser l'état des sons
    setSoundEnabled(notificationSoundService.areSoundsEnabled());
  }, []);

  // Fonction pour activer/désactiver les sons
  const toggleSound = () => {
    const newState = !soundEnabled;
    setSoundEnabled(newState);
    notificationSoundService.toggleNotificationSounds(newState);
    
    // Jouer un son pour confirmer que les sons sont activés
    if (newState) {
      notificationSoundService.playNotificationSound('default');
    }
    
    setMessage({ 
      type: 'success', 
      content: `Sons de notification ${newState ? 'activés' : 'désactivés'} avec succès!` 
    });
    
    // Effacer le message après 3 secondes
    setTimeout(() => {
      setMessage({ type: '', content: '' });
    }, 3000);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-xl font-medium mb-4">Préférences de notification</h2>
      
      {message.content && (
        <div className={`mb-4 p-3 rounded ${
          message.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}>
          {message.content}
        </div>
      )}
      
      <div className="mb-4">
        <div className="flex items-center justify-between py-4 border-b border-gray-200">
          <div>
            <h3 className="text-lg font-medium text-gray-900">Sons de notification</h3>
            <p className="text-sm text-gray-500">
              Activez ou désactivez les sons lors de la réception de nouvelles notifications
            </p>
          </div>
          <button
            onClick={toggleSound}
            className={`flex items-center space-x-2 px-3 py-2 rounded-md ${
              soundEnabled 
                ? 'bg-primary-100 text-primary-800 hover:bg-primary-200' 
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {soundEnabled ? (
              <>
                <FaVolumeUp className="mr-2" />
                <span>Activé</span>
              </>
            ) : (
              <>
                <FaVolumeMute className="mr-2" />
                <span>Désactivé</span>
              </>
            )}
          </button>
        </div>
        
        {/* Emplacement pour d'autres préférences de notification */}
      </div>
    </div>
  );
};

export default NotificationPreferences;